const GiftCardItemData = (props) => {
  const { email, giftMessage, onEmailChange, onGiftMessageChange } = props;
  const handleEmailChange = (e) => {
    onEmailChange(e.target.value);
  };
  const handleGiftMessageChange = (e) => {
    onGiftMessageChange(e.target.value);
  };
  return (
    <>
      <div className="c7-product__variant__gift-card">
        <label htmlFor="c7-recipient">
          Recipient Email:
          <br />
          <input
            id="c7-recipient"
            type="text"
            name="email"
            value={email}
            onChange={handleEmailChange}
          />
        </label>
      </div>
      <div className="c7-product__variant__gift-card">
        <label htmlFor="c7-giftMessage">
          Gift Message
          <br />
          <textarea
            id="c7-giftMessage"
            name="giftMessage"
            value={giftMessage}
            onChange={handleGiftMessageChange}
          />
        </label>
      </div>
    </>
  );
};

export default GiftCardItemData;
